import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import { aplicarTema, temaGuardado } from './lib/tema'
import './estilos.css'

// Antes de montar React: si el tema guardado es oscuro, que no se vea primero el
// fondo claro y luego el cambio.
aplicarTema(temaGuardado())

const cliente = new QueryClient({
  defaultOptions: {
    queries: {
      // El tiempo real es quien invalida; no hace falta refrescar por si acaso.
      refetchOnWindowFocus: false,
      retry: (intentos, error) => {
        const estado = (error as { estado?: number }).estado
        if (estado === 401 || estado === 403) return false
        return intentos < 2
      },
    },
  },
})

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <QueryClientProvider client={cliente}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
